import { Display, Moon, Sun } from '@gravity-ui/icons';
import { Segment } from '@heroui-pro/react';
import type { ReactNode } from 'react';
import { useSyncExternalStore } from 'react';

import { type ColorMode, currentAppearance, setColorMode, subscribeAppearance } from '../../theme.ts';

const OPTIONS: { id: ColorMode; label: string; icon: ReactNode }[] = [
  { id: 'auto', label: 'Follow the system', icon: <Display className="size-4" /> },
  { id: 'light', label: 'Light', icon: <Sun className="size-4" /> },
  { id: 'dark', label: 'Dark', icon: <Moon className="size-4" /> },
];

export function ThemeSwitch() {
  const mode = useSyncExternalStore(subscribeAppearance, () => currentAppearance().colorMode);
  return (
    <Segment aria-label="Colour mode" size="sm" className="w-full" selectedKey={mode} onSelectionChange={(key) => setColorMode(String(key) as ColorMode)}>
      {OPTIONS.map((o) => (
        <Segment.Item key={o.id} id={o.id} aria-label={o.label} className="flex-1 justify-center">
          <span title={o.label} className="inline-flex items-center">
            {o.icon}
          </span>
        </Segment.Item>
      ))}
    </Segment>
  );
}
